import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { numberFormatterInternational } from 'app/utils/telephonyHelpers';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { Callback as CallbackModal } from '../../modals/callback';
const translatePayload = (node) => {
    const { next_node_id } = node.payload;
    return [
        {
            id: uuid(),
            connection: next_node_id || uuid(),
            label: 'arrow',
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign({}, node.payload);
    payload.next_node_id = connectionId;
    return Object.assign(Object.assign({}, node), { payload });
};
export const CallbackNodeAttributes = {
    iconName: 'callback',
    label: 'Callback',
    color: hexStringToNumber(flowNodeColor.orange),
    translatePayload,
    updateConnection,
    NodeContent: CallbackNode,
    ActionModal: CallbackModal,
};
export const useAnnouncementName = (announcement, extraData) => {
    const { announcements: extraDataAnnouncements } = extraData;
    return useMemo(() => {
        var _a;
        const { url, label } = (announcement === null || announcement === void 0 ? void 0 : announcement.file) || {};
        if (label) {
            return label;
        }
        if (url) {
            const announcementInExtraData = extraDataAnnouncements.find((announcement) => announcement.url === url);
            if (announcementInExtraData === null || announcementInExtraData === void 0 ? void 0 : announcementInExtraData.pretty_name) {
                return announcementInExtraData.pretty_name;
            }
            const matchedUrlLabel = (_a = /([^/]+$)/.exec(url)) === null || _a === void 0 ? void 0 : _a.toString();
            if (matchedUrlLabel) {
                return matchedUrlLabel;
            }
        }
        return 'None';
    }, [announcement, extraDataAnnouncements]);
};
export function CallbackNode({ node, context, }) {
    const { extraData } = context;
    const { payload } = node;
    const announcement = useAnnouncementName(payload.announcement, extraData);
    const usedNumber = (payload === null || payload === void 0 ? void 0 : payload.from_number) || extraData.number;
    const phoneNumber = usedNumber
        ? numberFormatterInternational({ phoneNumber: usedNumber })
        : 'No number selected';
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(_Fragment, { children: [_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Announcement" }), _jsx(Text, { weight: "semibold", text: announcement })] }), _jsxs(TextEllipsis, Object.assign({ offset: { y: 5, x: 0 } }, { children: [_jsx(Text, { weight: "normal", text: "Outbound number" }), _jsx(Text, { weight: "semibold", text: phoneNumber })] }))] })), [announcement, phoneNumber]) }));
}
